// src/components/sections/AboutIntro.js
import React from 'react';
import { Link } from "react-router-dom";
import { PiRocketLaunchFill } from "react-icons/pi";
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

const AboutIntro = () => {
  return (
    <div className="text-white px-5 py-10 text-center">
      <div className="text-4xl font-semibold mb-8 pb-10">
        Leading Innovators in IT Solutions & Services
      </div>

      <div className="container mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 items-center text-left">
        {/* Image Column */}
        <div className="flex justify-center" data-aos="zoom-in-right" data-aos-duration="500">
          <DotLottieReact
            src="https://lottie.host/eab30bf2-7167-46ce-8e33-9b40398b5e88/DsuqLxC2q3.lottie"
            loop
            autoplay
          />
        </div>

        {/* Text Column */}
        <div className="space-y-6" data-aos="zoom-in-left" data-aos-duration="500">
          <p className='text-justify font-medium '>
            At <span className="font-semibold text-[#00d9ff]">VIVEKASOFTEK</span>, we specialize in delivering cutting-edge IT solutions that empower businesses to thrive in the digital age. From web development to cloud computing, our expertise covers a wide range of services tailored to meet the unique needs of our clients.
          </p>
          <p className='text-justify font-medium '>
            Our mission is to provide innovative, efficient, and reliable IT services that drive success. We are committed to excellence, ensuring that every project is completed with the highest standards of quality and performance.
          </p>
          <Link
            to="/aboutUs"
            className="group relative inline-flex items-center mt-4 h-12 rounded-full overflow-hidden bg-transparent border-2 border-white/40 text-white transition-all duration-500 px-4"
          >
            <span className="text-base pl-4 font-extrabold tracking-wide">
              Discover More
            </span>
            <span className="ml-0 opacity-0 transform -translate-x-2 text-white text-xl transition-all duration-500 group-hover:ml-3 group-hover:opacity-100 group-hover:translate-x-0">
              <PiRocketLaunchFill />
            </span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AboutIntro;